{
  "amount_to_pay": "Zu zahlender Betrag",
  "booking_number": "Buchungsnummer",
  "deposit": "Sofort zu zahlender Betrag (Anzahlung)",
  "description": "Bitte überweisen Sie die Anzahlung, um Ihre Buchung zu bestätigen.",
  "estimated_amount_in_dollars": "USD-Gegenwert auf der Grundlage des heutigen Wechselkurses",
  "full_amount": "Gestamtbetrag",
  "generic_error": "Es gab ein Problem mit der Zahlung. Bitte wenden Sie sich an Ihren Kreditkartenanbieter oder Ihre Bank, bevor Sie es erneut versuchen.",
  "interac": {
    "title": "Interac-Anleitung",
    "description": "Senden Sie eine Interac e-Transfer aus dem Online- oder Mobile-Banking Ihrer kanadischen Bank. Sobald der Transfer eingegangen ist, bestätigen wir Ihre Buchung.",
    "converted_at": "Umgerechnet zu {{eur}} ≈ {{cad}} — Kurs gültig bis {{valid_until}}",
    "quote_validity": "Dieses Angebot ist <strong>5 Tage</strong> gültig — bis {{valid_until}}. Danach wird der CAD-Betrag zum aktuellen Kurs neu berechnet.",
    "contact": "Fragen? Schreiben Sie an <a class=\"underline text-primary\" href=\"{{href}}\">info@boatbiketours.com</a>",
    "copy": "Kopieren",
    "sent": "Ich habe die e-Transfer gesendet",
    "steps": {
      "recipient": { "title": "Senden an (E-Mail)", "hint": "Fügen Sie diese Adresse als Empfänger in Ihrem Online-Banking hinzu." },
      "amount": { "title": "Betrag", "hint": "Senden Sie genau diesen Betrag. Abweichungen verzögern die Bestätigung." },
      "reference": { "title": "Verwendungszweck / Nachricht", "hint": "Fügen Sie dies in das Nachrichtenfeld ein, damit wir die Zahlung Ihrer Buchung zuordnen können." }
    }
  },
  "local_costs": "Kosten vor Ort (werden bei der Abfahrt bezahlt)",
  "methods": {
    "interac": {
      "title": "In CAD bezahlen",
      "description": "e-Transfer mit Interac",
      "badge": "NEU · CA"
    },
    "card": {
      "title": "In USD bezahlen",
      "description": "Kreditkarte oder ACH"
    }
  },
  "safe_secure_checkout": "Garantiert <1>sicher & geschützt</1> bezahlen",
  "powered_by_stripe": "Ermöglicht durch Stripe",
  "paid_amount_in_dollars": "Gezahlter Betrag in USD",
  "pay_deposit": "Eine Einzahlung vornehmen",
  "pay_full_amount": "Zahlen Sie den vollen Betrag",
  "payment_completed_title": "Vielen Dank für Ihre Zahlung",
  "payment_completed_description_deposit": "Ihre Anzahlung ist bei uns eingegangen.",
  "payment_completed_description_full": "Ihre vollständige Zahlung ist bei uns eingegangen.",
  "payment_completed_description_interac": "Ihre Zahlung ist unterwegs. Sobald Ihr Interac e-Transfer bei uns eingegangen ist, senden wir Ihnen eine Bestätigungs-E-Mail.",
  "payment_description": "Bitte fahren Sie mit der Zahlung für Ihre Buchung fort.",
  "payment_status": "Zahlungsstatus",
  "payment_title": "Begleichen Sie Ihre ausstehenden Zahlungen",
  "processing_message": "Die Zahlung befindet sich derzeit im Status ‘Processing’. Es kann 4–5 Werktage dauern, bis sie mit Ihrer Buchung abgeglichen ist. Anschließend erhalten Sie eine Zahlungsbestätigung und Ihre Buchungsbestätigung.",
  "retry": "Erneut versuchen",
  "status": {
    "canceled": "Fehlgeschlagen",
    "processing": "Wird verarbeitet",
    "succeeded": "Erfolgreich"
  },
  "title": "Vielen Dank für Ihre Buchung!",
  "total_amount": "Buchungsbetrag gesamt"
}
